import classNames from 'classnames';
import styles from './index.module.scss';
import Badge, {BadgeType} from '@/components/Badge';
import {GRAY_RELEASE_KEYS, initGray} from '@/grayRelease';

interface IRedDot {
    className?: string;
    count: number;
    max?: number;
    children: React.ReactNode;
}

function RedDot({
    className,
    count,
    children,
    max = 99,
}: IRedDot) {
    return <Badge
        className={classNames(styles.redDot, count < 10 && styles.circle, className)}
        content={count}
        max={max}
        type={BadgeType.Dot}
    >
        {children}
    </Badge>;
}
export default RedDot;
